import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'

import 'lib-flexible/flexible'
//import '../static/mui/css/mui.min.css'
import '../static/style.css'
import layer from 'vue-layer'
Vue.prototype.$layer = layer(Vue);

// 全局请求
import axios from 'axios'
Vue.prototype.$axios = axios
axios.defaults.baseURL = '';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
//axios.defaults.headers.post['Access-Control-Allow-Method'] = 'POST,GET';
//axios.defaults.headers.post['Authorization'] = 'WSSE realm="SDP", profile="UsernameToken", type="AppKey"';
//axios.defaults.headers.post['X-WSSE'] = 'UsernameToken Username="15002341415", PasswordDigest="333A13344455669333A", Nonce="asdfasdfasdfFAffasdf454FAdfa", Created: "2019-7-3 10:00"';

import api from '@/http/api.js' 
Vue.prototype.api = api;

import lzstring from '../static/lz-string.min.js' 
Vue.prototype.lzstring = lzstring;

/*import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
let options = {
  clickToCloseNonZoomable: true,
}
Vue.use(preview, options)
Vue.use(preview)*/


import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';

Vue.use(Viewer, {
  defaultOptions: {
	zIndex: 9999,
	"toolbar": false, 
	"navbar": false,
	"title": false,
	"tooltip": false,
	"movable": true,
	"zoomable": true,
	"rotatable": true,
	"scalable": true,
  }
})


Vue.config.devtools = false;
Vue.config.productionTip = false;

//设置title
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)


import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
/* eslint-disable no-new */

import publics from '@/public/public.js'
Vue.prototype.$publics = publics

//import loading from 'vue-nice-loading'
import loading from '@/vue-nice-loading/src/'
Vue.use(loading)

import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
Vue.use(VueDirectiveImagePreviewer,{
	zIndex:9999,
	previewSize: 3 //三倍图
}) 

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
/*router.beforeEach((to, from, next) => {	
  if (to.matched.some(record => record.meta.requireAuth)) {
      //这里判断用户是否登录，验证本地存储是否有token
      if (sessionStorage.getItem('guide')!='guide') { // 判断当前的token是否存在
          next({
              path: '/guide',
          })
      } else {
          next()
      }
  } else {
      next() // 确保一定要调用 next()
  }
})*/



// WEBPACK FOOTER //
// ./src/main.js